export default __webpack_public_path__ + "static/media/0146.c05f345b.jpg";